const getFetchHeaders = require("./getFetchHeaders");
const fetchAnonymousContent = require("./fetchAnonymousContent");
const getFetchAgent = require("./getFetchAgent");
const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = async function fetchAs({
	endpoint,
	headers = null,
	agent = null,
	extraParams = {},
	method = "GET",
	ssr = false,
	body = null,
	query = {},
	isPrivateLayout = false,
	authContext,
}) {
	const { useDefaultJsonApiPath = true, returnResponse = false } = extraParams;

	if (
		authContext &&
		authContext[1] &&
		authContext[1].isLoggedIn &&
		authContext[1].isLoggedIn()
	) {
		let response = await fetchAuthenticatedContent({
			endpoint,
			method,
			body,
			headers,
			extraParams,
			query,
			dispatch: authContext[1].dispatch,
		});
		return response;
	} else {
		if (isPrivateLayout) {
			return { error: "User is not authenticated" };
		} else {
			const jsonapiBase = useDefaultJsonApiPath ? "/jsonapi" : "";
			let queryString = "";
			if (query && Object.keys(query).length > 0) {
				queryString += endpoint.includes("?") ? "&" : "?";
				queryString += new URLSearchParams(query).toString();
			}
			const url = `${process.env.CLF_BACKEND_URL}${jsonapiBase}/${endpoint}${queryString}`;
			let _headers = getFetchHeaders();
			if (ssr) {
				agent = getFetchAgent();
			} else if (headers) {
				_headers = { ..._headers, ...headers };
			}
			let _response = await fetchAnonymousContent(
				url,
				method,
				body,
				_headers,
				agent,
				returnResponse
			);
			return _response;
		}
	}
};
